import { getTeams } from '../../actions/userActions/teamAction'
import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import {
  addDoctors,
  getDoctorSuggestions,
  updateDoctors,
} from '../../actions/userActions/doctorAction'
import Loader from '../subComponents/Loader'
import { getCities } from '../../actions/userActions/cityAction'
import { getDoctorRanks } from '../../actions/userActions/doctorRankAction'
import { getDoctorSpecializations } from '../../actions/userActions/doctorSpecializationAction'
import { Redirect } from 'react-router-dom'
import { useLocation, useHistory } from 'react-router-dom'
import { getCustomerRank } from '../../actions/userActions/customerRankAction'
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import TextField from "../designSystem/TextField";
import chevron_rightIcon from "../../assets/images/chevron_rightIcon.svg";
import Select from "@mui/material/Select";
import SaveButton from '../subComponents/buttons/SaveButton'
import { Autocomplete, CircularProgress, IconButton } from '@mui/material'
import HrComponent from '../reuse_components/HrComponent'
import { getPracticeLocations } from '../../actions/userActions/practiceLocationAction'
import SingleSelect from '../designSystem/SingleSelect'
import PrimaryButton from '../subComponents/buttons/PrimaryButton'
import BodySmallMedium from '../designSystem/BodySmallMedium'
import Heading6Regular from '../designSystem/Heading6Regular'
import deleteIcon from "../../assets/images/deleteIcon_drawer.svg";
import CancelButton from '../subComponents/buttons/CustomCancelButton'
import MultiSelect from '../designSystem/MultiSelect'
import Doctorpracticelocationrow from './doctorpracticelocationrow'
import AddButton from '../subComponents/buttons/CustomAddButton'
import "./AddDoctor.css";
import { Check } from 'lucide-react'
import { validateFields } from '../../utils/Validations'
import {
  DEFAULT_PAGE,
  DEFAULT_SEARCH,
  DEFAULT_CITY,
  DEFAULT_PAGE_SIZE
} from '../../Constatns';
import { PERMISSIONS } from '../../Permissions'
import BodyExtraSmallMedium from '../designSystem/BodyExtraSmallMedium'
import BodySmallRegular from '../designSystem/BodySmallRegular'
import BackNavHeader from '../subComponents/BreadCrumbs/BackNavHeader '
import cityicon from "../../assets/images/cityIcon (2).svg";
import customerrankicon from "../../assets/images/customerrankicon.svg";
import AddNewForm from '../addNew/AddNewForm'
import AddNewDrawer from '../addNew/AddNewDrawer'
import doctorspeicon from "../../assets/images/doctorspeicon.svg";
import doctorRankIcon from "../../assets/images/Icon=Doctor Ranks.svg";
import LoadingOverlay from '../loadingOverlay/LoadingOverlay'
import { t } from '../../locales/translate'

function AddDoctors() {
  const dispatch = useDispatch()
  const location = useLocation()
  const history = useHistory()

  const initialValues = {
    name: '',
    pmdcnumber: '',
    specialization: '',
    rank: '',
    customerRankId: '',
    contact1: '',
    contact2: '',
    city: null,
    email: '',
    active: false,
    teams: [], 
    rows: [
      {
        cityId: 0,
        practiceLocationIds: []
      }
    ],
  }
  const [selectedPracticeLocations, setSelectedPracticeLocations] = useState([]);
  const [formValues, setFormValues] = useState(initialValues)

  const [page, setPage] = useState(1)

  const [cityFilters, setCityFilters] = useState({
    textSearch: '',
    countryId: '1',
  })
  const cityBody = {
    filter: cityFilters,
    pageNumber: -1,
    pageSize: 0,
  };
  const teams = useSelector((state) => state.teams_reducer.teams);
  const isTeamsLoading = teams === "isLoading";
const teamsData = !isTeamsLoading && teams?.result;
  const allCities = useSelector((state) => state.cities_reducer.cities);
  const ranks = useSelector((state) => state.doctor_rank_reducer.ranks);
  const ranksData = ranks && ranks.result;

  const specializations = useSelector(
    (state) => state.doctor_specialization_reducer.specializations
  );
  const specializationsData = specializations && specializations.result;
  const doctorSuggestions = useSelector(state => state.doctors_reducer.doctorSuggestions);
 const addDoctor = useSelector((state) => state.doctors_reducer.addDoctors);
  const updateDoctor = useSelector((state) => state.doctors_reducer.updateDoctors);
  const permissions = JSON.parse(localStorage.getItem('permissionsList'));
  const customerRanks = useSelector((state) => state.customer_rank_reducer.customerRank);
  const practiceLocations = useSelector((state) => state.practiceLocations_reducer?.practiceLocations);
  const pageNumber = -1;
  const [loading, setLoading] = useState(true);
  const DOCTOR_STATE_KEY = 'doctorState';
  const DOCTOR_ADD_STATE_KEY = 'doctorAddState';
  const DOCTOR_PATH = '/admin/doctors';
  const [formErrors, setFormErrors] = useState({})
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [drawerItem , setDrawerItem] = useState(null);
  const [drawerLoading, setDrawerLoading] = useState(false);

    const DRAWER_ICONS = {
      city: cityicon,
      customerRank: customerrankicon,
      doctorSpecialization: doctorspeicon,
      doctorDesignation: doctorRankIcon
        };
  const darwerIcon = DRAWER_ICONS[drawerItem] ? <img src={DRAWER_ICONS[drawerItem]} alt={drawerItem} /> : null;

  const handleselectChange = (event, fieldName) => {
    setFormValues((prevValues) => ({
      ...prevValues,
      [fieldName]: event.value,
    }));
  };

   const handleAddNew = (itemName) => {
  setDrawerItem(itemName);
  setDrawerOpen(true);
};

useEffect(() => {
  const saveState = () => {
    if (location.state?.fromDoctor || location.doctors) {
      sessionStorage.setItem(DOCTOR_STATE_KEY, JSON.stringify({
        page: location.state?.page || DEFAULT_PAGE,
        search: location.state?.search || DEFAULT_SEARCH,
        city: location.state?.city || DEFAULT_CITY,
        pageSize: location.state?.pageSize || DEFAULT_PAGE_SIZE,
        designation: location.state?.designation || 0,
        specialization: location.state?.specialization || 0,
        customerRank: location.state?.customerRank || 0,
        practiceLocation: location.state?.practiceLocation || 0,
        showFilters: location.state?.showFilters || false
      }));
    }
  };

  window.addEventListener('beforeunload', saveState);

  if (!location.state?.fromDoctor && !location.doctors && sessionStorage.getItem(DOCTOR_STATE_KEY)) {
    try {
      const saved = JSON.parse(sessionStorage.getItem(DOCTOR_STATE_KEY));
      history.replace({
        ...location,
        state: {
          fromDoctor: true,
          page: saved.page,
          search: saved.search,
          city: saved.city,
          pageSize: saved.pageSize,
          designation: saved.designation,
          specialization: saved.specialization,
          customerRank: saved.customerRank,
          practiceLocation: saved.practiceLocation,
          showFilters: saved.showFilters
        }
      });
    } catch (e) {
      console.error("Error restoring state", e);
    }
  }
  return () => window.removeEventListener('beforeunload', saveState);
}, [location, history]);
useEffect(() => {
  if (location.state && location.state.fromDoctor) {
    sessionStorage.setItem(DOCTOR_ADD_STATE_KEY, JSON.stringify({
      page: location.state.page || DEFAULT_PAGE,
      search: location.state.search || DEFAULT_SEARCH,
      city: location.state.city || DEFAULT_CITY,
      pageSize: location.state.pageSize || DEFAULT_PAGE_SIZE,
      designation: location.state.designation || 0,
      specialization: location.state.specialization || 0,
      customerRank: location.state.customerRank || 0,
      practiceLocation: location.state.practiceLocation || 0,
      showFilters: location.state.showFilters || false
    }));
  }
}, [location.state]);

const getCityNameById = (cityId) => {
  if (!allCities?.result || !allCities.result[0]?.cities) return "";
  const cityObj = allCities.result[0]?.cities.find(city => city.id === parseInt(cityId));
  return cityObj?.name || "";
};
const navigateBack = () => {
  let page = DEFAULT_PAGE;
  let search = DEFAULT_SEARCH;
  let city = DEFAULT_CITY;
  let pageSize = DEFAULT_PAGE_SIZE;
  let designation = 0;
  let specialization = 0;
  let customerRank = 0;
  let practiceLocation = 0;
  let showFilters = false;
  
  if (location.state && location.state.fromDoctor) {
    page = parseInt(location.state.page) || DEFAULT_PAGE;
    search = location.state.search || DEFAULT_SEARCH;
    city = parseInt(location.state.city) || DEFAULT_CITY;
    pageSize = parseInt(location.state.pageSize) || DEFAULT_PAGE_SIZE;
    designation = parseInt(location.state.designation) || 0; 
    specialization = parseInt(location.state.specialization) || 0; 
    customerRank = parseInt(location.state.customerRank) || 0; 
    practiceLocation = parseInt(location.state.practiceLocation) || 0; 
    showFilters = location.state.showFilters || false;  
  } else {   
    try {
      const savedState = sessionStorage.getItem(DOCTOR_ADD_STATE_KEY);
      if (savedState) {
        const parsedState = JSON.parse(savedState);
        page = parseInt(parsedState.page) || DEFAULT_PAGE;
        search = parsedState.search || DEFAULT_SEARCH;
        city = parseInt(parsedState.city) || DEFAULT_CITY;
        pageSize = parseInt(parsedState.pageSize) || DEFAULT_PAGE_SIZE;
        designation = parseInt(parsedState.designation) || 0;
        specialization = parseInt(parsedState.specialization) || 0;
        customerRank = parseInt(parsedState.customerRank) || 0;
        practiceLocation = parseInt(parsedState.practiceLocation) || 0;
        showFilters = parsedState.showFilters || false;
      }
    } catch (e) {
      console.error("Error retrieving state", e);
    }
  }  
    
  
  const searchParams = new URLSearchParams();
  searchParams.set('page', page);
  searchParams.set('pageSize', pageSize);
  if (search) searchParams.set('search', search); 
  const cityName = getCityNameById(city);
  if (cityName) {
    searchParams.set('city', cityName);
  } else {
    searchParams.set('city', city);
  }
  history.push({
    pathname: DOCTOR_PATH,
    search: searchParams.toString() ? `?${searchParams.toString()}` : '',
    state: {
      returnToDoctor: true,
      page,
      search,
      city,
      pageSize,
      designation,  
      specialization,  
      customerRank,  
      practiceLocation,
      showFilters  
    }
  });
}
  
  const handleGoBack = () => {
    navigateBack();
  };
 const getOptions = (type) => {
    switch (type) {
      case "cities":
        return allCities?.result.length
          ? allCities?.result
            .sort((a, b) => a.name.localeCompare(b.name))
            .map((city) => ({
              value: city.id,
              label: city.name,
            }))
          : [];
      case "customerRank":
        return customerRanks !== "isLoading" && customerRanks?.result?.length
          ? customerRanks.result
            .map((customerRank) => ({
              value: customerRank.customerRankId,
              label: customerRank.rankName,
            }))
          : [];
      case "specialization":
        return specializationsData?.length
          ? specializationsData
            .map((specialization) => ({
              value: specialization.id,
              label: specialization.name,
            }))
          : [];
      case "designation":
        return ranksData?.length
          ? ranksData
            .filter((rank) => rank.active === true)
            .map((rank) => ({
              value: rank.id,
              label: rank.name,
            }))
            .filter((rank) => rank.value)
          : [];
           case "teams":
            if (isTeamsLoading) return null;   
            return teamsData?.length
              ? teamsData.map((team) => ({
                  value: team.id,
                  label: team.name,
                }))
              : [];
      default:
        return [];
    }
  };
  useEffect(() => {
    const fetchData = async () => {
      try {
        dispatch(getCities(cityBody));
        dispatch(getDoctorRanks(pageNumber));
        dispatch(getDoctorSpecializations(pageNumber));
        dispatch(getCustomerRank(-1));
        dispatch(getTeams(-1, 0, ""));
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);
  useEffect(() => {
    if (location.doctors) {
      
      setFormValues({
        ...formValues,
        name: location.doctors.row.name,
        pmdcnumber: location.doctors.row.pmdcnumber,
        specialization: location.doctors.row.specialization,
        rank: location.doctors.row.rank,
        customerRankId: location.doctors.row.customerRankId,
        contact1: location.doctors.row.contact1,
        contact2: location.doctors.row.contact2,
        city: location.doctors.row.city,
        id: location.id,
        email: location.doctors.row.email?.trim(),
        active: location.doctors.row.active,
        teams: (location.doctors.row.teams || []).map(team => team.id),
        rows: location.doctors.row.doctorPracticeLocations.map(loc => ({
          cityId: loc.cityId,
          cityName: loc.cityName,
          practiceLocationIds: loc.practiceLocations.map(pl => pl.id)
        }))
      });
    }
  }, [location.doctors]);
  useEffect(() => {
    if (location.doctors?.row?.doctorPracticeLocations) {
      location.doctors.row.doctorPracticeLocations.forEach(loc => {
        const practiceLocationBody = {
          pageNumber: -1,
          filter: { textSearch: "", city: loc.cityId },
          pageSize: 0,
        };
        dispatch(getPracticeLocations(practiceLocationBody));
      });
    }
  }, [location.doctors]);
const handleMultiSelectChange = (selectedOptions, fieldName) => {
  setFormValues((prev) => ({
    ...prev,
    [fieldName]: selectedOptions || [],
  }));
};
  const handleSubmit = async (e) => {
    e.preventDefault();
    const errors = validateFields(formValues, 'doctor');
    setFormErrors(errors);
    if (Object.keys(errors).length === 0) {
      const formattedData = {
        ...formValues,
       teams: formValues.teams || [],
        doctorPracticeLocations: formValues.rows.map(row => ({
          cityId: row.cityId,
          cityName: row.cityName,
          practiceLocationIds: row.practiceLocationIds
        }))
      };
      if (location.doctors) {
        dispatch(updateDoctors(formattedData))
          .then(() => navigateBack());
      } else {
        dispatch(addDoctors(formattedData))
          .then(() => navigateBack());
      }
    }
  };

  // if (loading) {
  //   return (
  //     <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '75vh' }}>
  //       <CircularProgress size={60} style={{ color: '#002D72' }} />
  //     </div>
  //   );
  // }
  const handlechange = (event) => {
    const { name, type, checked, value } = event.target;

    const updatedValue = type === "checkbox" ? checked : value;

    setFormValues({
      ...formValues,
      [name]: updatedValue,
    });
  };
  const handleDoctorNameInputChange = (doctorName) => {
    dispatch(getDoctorSuggestions(doctorName));
  };
  const renderDoctorSuggestions = (doctorSuggestions) => {
    return doctorSuggestions.map((doctor, index) => (
      <div key={index} className="suggestion-item">
        <Heading6Regular text={doctor.name}/>
        {(doctor.specializationName || doctor.cityName) && (
  <BodySmallRegular
    text={
      doctor.specializationName && doctor.cityName
        ? `${doctor.specializationName} • ${doctor.cityName}`
        : doctor.specializationName || doctor.cityName
    }
  />
)}
      </div>
    ));
  };
  const handletextChange = (event) => {
    const { name, value } = event.target;

    let updatedValue = value;

    if (name === "contact1" || name === "contact2") {
      updatedValue = value.replace(/[^0-9]/g, "").slice(0, 13);
    } else if (name === "email") {
      updatedValue = value.trim();
    }

    setFormValues({
      ...formValues,
      [name]: updatedValue,
    });
  };

  const handleRemoveRow = (rowIndex) => {
    setFormValues((prevState) => ({
      ...prevState,
      rows: prevState.rows.filter((_, index) => index !== rowIndex),
    }));
  };

  const handleAddRow = () => {
    setFormValues((prevState) => ({
      ...prevState,
      rows: [
        ...prevState.rows,
        {
          cityId: 0,
          practiceLocationIds: []
        }
      ],
    }));
  };
  const handleCityChange = (event) => {
    setFormValues({
      ...formValues,
      city: event.value,
      cityName: event.label
    })
  }
  return (
  <>
    {addDoctor && addDoctor !== "isLoading" && (
      <Redirect to="/admin/doctors" />
    )}
    {updateDoctor && updateDoctor != "isLoading" && <Redirect to="/admin/doctors" />}
    {!permissions.includes(PERMISSIONS.CAN_ADD_DOCTOR) && <Redirect to="/admin" />}
    {!permissions.includes(PERMISSIONS.CAN_UPDATE_DOCTOR) && <Redirect to="/admin" />}
    {!location.doctors && <Redirect to={'/admin/AddDoctors'} />}
    <div className="add-doctor-container" style={{ position: 'relative', minHeight: '100vh', borderRadius: '8px', overflow: 'hidden' }}>  <LoadingOverlay 
    isVisible={
      allCities === "isLoading" || 
      customerRanks === "isLoading" || 
      addDoctor === "isLoading" || 
      isTeamsLoading ||
      updateDoctor === "isLoading"
    }
  />
  <BackNavHeader text={t("addDoctor")} onBack={handleGoBack} />
  <div className="add-content-wrapper">
          <div className="row">
            <div className="col-4">
            <TextField
              name="name"
              label={`${t("doctorName")} *`}
              type="text"
              value={formValues.name}
              onChange={handletextChange}
              placeholder={t("doctorName")}
              error={formErrors.name}
              enableSuggestions={true}
              suggestions={doctorSuggestions || []}
              minCharsForSuggestions={3}
              onSuggestionInputChange={handleDoctorNameInputChange}
              renderSuggestions={renderDoctorSuggestions} // Custom render function
            />           
            </div>

            <div className="col-4">
              <SingleSelect
                label={`${t("city")} *`}
                isSearchable
                iconEnd
                error={formErrors.city}
                onChange={handleCityChange}
                value={formValues.city}
                placeholder={t("city")}
                options={(allCities &&
                  allCities !== "isLoading" &&
                  allCities.length !== 0 && allCities?.result &&
                  allCities.result?.length !== 0)
                  && getOptions("cities")}
                configKey={"city"}
                onAddNewClick={() => handleAddNew("city")}
              />
            </div>
            <div className="col-4">
              <SingleSelect
                label={`${t("designation")} *`}
                value={formValues.rank}
                error={formErrors.rank}
                onChange={(option) => handleselectChange(option, "rank")}
                options={getOptions("designation")}
                placeholder={t("designation")}
                isSearchable
                configKey={"doctorDesignation"}
                onAddNewClick={() => handleAddNew("doctorDesignation")}
              />
            </div>
          </div>
          <div className="row">
            <div className="col-4">
              <SingleSelect
                label={`${t("specialization")} *`}
                value={formValues.specialization}
                error={formErrors.specialization}
                onChange={(option) => handleselectChange(option, "specialization")}
                options={getOptions("specialization")}
                placeholder={t("specialization")}
                isSearchable
                configKey={"doctorSpecialization"}
                onAddNewClick={() => handleAddNew("doctorSpecialization")}
              />
            </div>
             <div className="col-4">
              <SingleSelect
                options={getOptions("customerRank")}
                value={formValues.customerRankId}
                onChange={(option) => handleselectChange(option, "customerRankId")}
                label={`${t("customerRank")} *`}
                placeholder={t("customerRank")}
                isSearchable
                error={formErrors.customerRankId}
                configKey={"customerRank"}
                onAddNewClick={() => handleAddNew("customerRank")}
              />
  
            </div>
            <div className="col-4">
              <TextField
                name="email"
                label={t("emailLabel")}
                type='text'
                value={formValues.email}
                onChange={handletextChange}
                placeholder={t("emailLabel")}
              />
            </div>
          </div>
          <div className="row">
            <div className="col-4">
              <TextField
                name="contact1"
                label={`${t("contact")} 1`}
                type='text'
                value={formValues.contact1}
                onChange={handletextChange}
                placeholder={`${t("contact")} 1`}
              />

            </div>
            <div className="col-4">
              <TextField
                name="contact2"
                label={`${t("contact")} 2`}
                type='text'
                value={formValues.contact2}
                onChange={handletextChange}
                placeholder={`${t("contact")} 2`}
              />
            </div>
                <div className="col-4">
            <MultiSelect
              label={t("Teams")}
              value={formValues.teams}
              onChange={(selectedOptions) => handleMultiSelectChange(selectedOptions, "teams")}
              options={getOptions("teams") || []}
              isLoading={isTeamsLoading}           
              isDisabled={isTeamsLoading}         
              placeholder={ t("Teams")}
              isSearchable
            />
          </div>
          </div>
          <div className="add-doctor-row-container">
            {formValues.rows.map((row, index) => (
              <Doctorpracticelocationrow
                key={index}
                row={row}
                index={index}
                formValues={formValues}
                formErrors={formErrors}
                setFormValues={setFormValues}
                setFormErrors={setFormErrors}
                handleRemoveRow={handleRemoveRow}
              />
            ))}
            <div className="add-doctor-form-actions-left">
              <AddButton
                onClick={handleAddRow}
                text={t("addAnother")}
              />

            </div>
          </div>
          <div className="form-group mt-5" style={{ display: "flex", alignItems: "flex-start" }}>
            <input
              name="active"
              style={{ cursor: "pointer", height: "16px", width: "16px" }}
              type="checkbox"
              checked={formValues.active}
              className="ml-2 mt-1"
              onChange={handlechange}
            />
            <label
              style={{ paddingLeft: "10px", }}
              className="form-control-label"
            >
              {t("active")}
            </label>
          </div>
          <HrComponent />
          <div className="add-doctor-form-actions">
            <CancelButton onClick={handleGoBack} text={t("cancel")} width={document.body.dir === "rtl" ? "119px" : ""} />
            <PrimaryButton
              onClick={handleSubmit}
              
              text={location.doctors ? `${t("update")}` : `${t("save")}`}
              icon={Check}
              width={location.doctors ? "95px" : document.body.dir === "rtl" ? "123px" : ""}
            />

          </div>
        </div>
      </div>
            <AddNewDrawer
  open={drawerOpen}
  onClose={() => setDrawerOpen(false)}
  title={drawerItem? t("addItem").replace(/{{item}}/g, t(drawerItem)): ""}
  subtext={drawerItem ? t("createNewItemRecord").replace(/{{item}}/g, t(drawerItem)) : ""}
  icon={darwerIcon}
  loading={drawerLoading}
>
          {drawerItem  && (
           <AddNewForm
              itemName={drawerItem }
              onClose={() => setDrawerOpen(false)}
              onLoadingChange={setDrawerLoading}
              onSave={(newData) => {
                if (drawerItem  === "city") {
                  dispatch(getCities(cityBody)).then(() => {
                    setFormValues((prev) => ({
                      ...prev,
                      value: newData.id,
                      label: newData.name
                    }));
                  });
                }

                if (drawerItem  === "doctorDesignation") {
                  dispatch(getDoctorRanks(pageNumber)).then(() => {
                    setFormValues((prev) => ({
                      ...prev,
                      value: newData.id,
                      label: newData.name
                    }));
                  });
                }

                if (drawerItem  === "doctorSpecialization") {
                  dispatch(getDoctorSpecializations(pageNumber)).then(() => {
                    setFormValues((prev) => ({
                      ...prev,
                      value: newData.id,
                      label: newData.name
                    }));
                  });
                }

                if (drawerItem  === "customerRank") {
                  dispatch(getCustomerRank()).then(() => {
                    setFormValues((prev) => ({
                      ...prev,
                      value: newData.id,
                      label: newData.name
                    }));
                  });
                }
              }}
            />

          )}
        </AddNewDrawer>

    </>
  )
}

export default AddDoctors
